<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">

        <ContractComponent/>

    </transition>
  </div>
</template>

<script>

import ContractComponent from '@/components/contracts/ContractComponent.vue'

export default {
  name: 'Contract',
  components: {
    ContractComponent
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";
</style>

<style scoped lang="scss">
</style>
